<template>
  <v-dialog max-width="480px" v-model="showDialog" persistent>
    <v-card>
      <v-card-title class="secondary white--text py-3 px-5">
        <span class="text-subtitle-1 font-weight-bold">Update Trailer</span>
        <v-spacer />
        <v-btn icon color="white" small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-5 pt-4">
        <div class="caption grey--text mb-3" v-if="trip">
          <strong>{{ trip.trip_id }}</strong> · Trailer Mode: {{ trip.trailer_mode || "-" }}
        </div>
        <v-row dense>
          <v-col cols="12">
            <Autocomplete
              label="Trailer 1 *"
              :items="trailerList"
              itemText="trailer_number"
              itemValue="id"
              :loading="trailerLoading"
              :totalItems="trailerCount"
              @updateList="fetchTrailers"
              hide-details="auto"
              v-model="form.trailer_1"
            />
          </v-col>
          <v-col cols="12" v-if="isBoggie">
            <Autocomplete
              label="Trailer 2 *"
              :items="trailerList"
              itemText="trailer_number"
              itemValue="id"
              :loading="trailerLoading"
              :totalItems="trailerCount"
              @updateList="fetchTrailers"
              hide-details="auto"
              v-model="form.trailer_2"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mt-3" />

      <v-card-actions class="px-5 py-3">
        <v-spacer />
        <v-btn depressed outlined @click="closeDialog" class="mr-2">Cancel</v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="submitting"
          :disabled="!isFormValid"
          min-width="120"
          @click="submit"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Autocomplete from "@/components/FormBaseComponents/Autocomplete.vue";

export default {
  name: "UpdateTrailerDialog",
  components: { Autocomplete },
  props: {
    value: { type: Boolean, default: false },
    trip: { type: Object, default: null },
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
        this.fetchTrailers({ limit: 10, offset: 0 });
      }
    },
  },
  data() {
    return {
      form: { trailer_1: null, trailer_2: null },
      trailerList: [],
      trailerCount: 0,
      trailerLoading: false,
      submitting: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isBoggie() {
      return this.trip && this.trip.trailer_mode === "Boggie";
    },
    isFormValid() {
      if (!this.form.trailer_1) return false;
      if (this.isBoggie && !this.form.trailer_2) return false;
      return true;
    },
  },
  methods: {
    resetForm() {
      this.form = { trailer_1: null, trailer_2: null };
    },
    closeDialog() {
      this.showDialog = false;
    },
    fetchTrailers(params = {}) {
      this.trailerLoading = true;
      this.$api.trailer
        .getTrailerSelectList({ limit: 10, ...params })
        .then((res) => {
          this.trailerList = params.offset ? [...this.trailerList, ...res.data] : res.data;
          this.trailerCount = res.count;
        })
        .finally(() => {
          this.trailerLoading = false;
        });
    },
    submit() {
      if (!this.trip) return;
      this.submitting = true;
      const getVal = (v) => (v && typeof v === "object" ? v.id : v);
      const trailerIds = [{ id: getVal(this.form.trailer_1) }];
      if (this.isBoggie) {
        trailerIds.push({ id: getVal(this.form.trailer_2) });
      }
      this.$api.draftTrip
        .updateDraftTripTrailer(this.trip.id, { trailer_ids: trailerIds })
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Trailer updated successfully!",
            color: "success",
          });
          this.$emit("updated");
          this.closeDialog();
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message:
              (err?.data?.trailer_ids && err.data.trailer_ids[0]) ||
              err?.data?.detail ||
              err?.message ||
              "Failed to update trailer.",
            color: "error",
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
